import { createIcon, Svg } from "@gluestack-ui/icon";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

const OtherIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 23 23",
  path: (
    <>
      <G clip-path="url(#clip0_1035_9121)">
        <Path
          d="M18.9091 8.83915C22.1948 13.472 19.6812 18.7784 18.4655 20.8484C18.2872 21.138 18.0478 21.385 17.764 21.5723C17.4803 21.7596 17.159 21.8826 16.8227 21.9327C14.4405 22.3434 8.5098 22.8034 5.32266 18.1706C2.1848 13.8006 2.31623 6.112 2.59552 2.44843C2.60653 2.17548 2.68221 1.90905 2.81632 1.67107C2.95044 1.43309 3.13915 1.23036 3.36694 1.07957C3.59472 0.928787 3.85506 0.834253 4.12652 0.803754C4.39798 0.773255 4.67281 0.807663 4.92837 0.904145C8.46052 1.92272 15.8205 4.46915 18.9091 8.83915Z"
          fill="none"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M7.83649 7.3125C11.5995 11.747 14.9022 16.5524 17.6936 21.6546"
          fill="none"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1035_9121">
          <Rect width="23" height="23" fill="white" />
        </ClipPath>
      </Defs>
    </>
  ),
});

OtherIcon.displayName = "OtherIcon";
export { OtherIcon };
